module.exports = __webpack_public_path__ + "img/step3.44b128be.png";